import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h5>{`Track 2: Technical Implementation`}</h5>
    <ul>
      <li parentName="ul">{`Have you ever encountered massive problems with non-functional requirements of architectural designs and functional requirements of business logic during software development?`}</li>
      <li parentName="ul">{`Do you still build up more technical debt while doing rapid iterative tasks to satisfy the high growth of the business?`}</li>
      <li parentName="ul">{`If we choose an inappropriate design pattern and architecture at a bad time, the maintenance burden rises.`}</li>
      <li parentName="ul">{`Facing the trade-off between lack of design and over-design, we have to understand what to choose and what to abandon under different scenarios.`}</li>
      <li parentName="ul">{`Including:`}<ol parentName="li">
          <li parentName="ol">{`Several application scenarios using DDD tactics.`}</li>
          <li parentName="ol">{`Topics for DDD architecture design.`}</li>
          <li parentName="ol">{`Relevant design patterns.`}</li>
        </ol></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      